import type React from 'react';
import { getNodeTestProps } from '@/utils';
import { SellerTopBar, ProductPanel, CartPanel } from './components';
import { HomeFocusProvider } from './HomeFocusProvider';

/**
 * Full-screen POS layout: a top bar over a two-pane body — product browser on
 * the left (fluid), cart on the right (fixed width). Render-only; all state
 * comes from `useSeller()` inside the panels. `HomeFocusProvider` wraps the
 * whole screen (bos-seller#60: the top bar's `ShiftActionButton` is a home
 * position too, while no shift is open) so any panel can send focus back to
 * the search field it doesn't own (see `useHomeFocus`).
 */
export const SellerView: React.FC = () => (
    <HomeFocusProvider>
        <div
            className="flex h-screen flex-col overflow-hidden bg-background text-foreground"
            {...getNodeTestProps('seller-screen')}
        >
            <SellerTopBar />
            <div className="flex flex-1 overflow-hidden">
                <ProductPanel />
                <CartPanel />
            </div>
        </div>
    </HomeFocusProvider>
);
